export default {
    actionable: {
        spelling: {
            background: 'bg-spelling-red-500',
            text: 'text-spelling-red-500',
            hover: 'hover:bg-spelling-red-100',
            border: 'border-spelling-red-500',
            backgroundLight: 'bg-spelling-red-100',
        },
        grammar: {
            background: 'bg-grammar-blue-500',
            text: 'text-grammar-blue-500',
            hover: 'hover:bg-grammar-blue-100',
            border: 'border-grammar-blue-500',
            backgroundLight: 'bg-grammar-blue-100',
        },
        style: {
            background: 'bg-style-green-500',
            text: 'text-style-green-500',
            hover: 'hover:bg-style-green-100',
            border: 'border-style-green-500',
            backgroundLight: 'bg-style-green-100',
        },
    },
    informational: {
        spelling: {
            background: 'bg-spelling-red-300',
            text: 'text-spelling-red-300',
        },
        grammar: {
            background: 'bg-grammar-blue-300',
            text: 'text-grammar-blue-300',
        },
        style: {
            background: 'bg-style-green-300',
            text: 'text-style-green-300',
        },
    },
};
